export enum ScriptExecuteTimingKinds {
  None = 0,
  PatientInformationUpdated = 1,
  DocumentEditBegun = 2,
  DocumentRegistered = 3,
  DocumentRegisteredAsTemporary = 4,
  DocumentRegisteredAsAny = 5,
  Calculated = 6,
  Clicked = 7,
}

export interface IScriptExecuteBehavior {
  timing: ScriptExecuteTimingKinds;
  scriptPath: string;
  separator: string;
  parameters: IScriptExecuteParameter[];
  csvFilePathFormat: string;
  valuesXmlPathFormat: string;
  previousValuesCsvFilePathFormat: string;
}

export interface IScriptExecuteParameter {
  isFixed: boolean;
  parameter: string;  // 固定値の場合は値、可変値の場合はキー.
}
